// extracted by mini-css-extract-plugin
export default {"analytics-wrapper":"styles_analytics-wrapper__6kskZ","analytics-grid":"styles_analytics-grid__AnwKj","analytics-col":"styles_analytics-col__09xoV"};